import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { JobComment, HttpResponse } from "@/types";

export function useDeleteJobComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ jobCommentId }: { jobCommentId: number }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-comments/${jobCommentId.toString()}`;
      const res = await guacHttpClient.delete<
        JobComment,
        HttpResponse<JobComment>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
